export default __webpack_public_path__ + "static/LochFyneWhiskies-80a9cedbed7b46cca5d3f5317aa874a4.png";